<template>
  <VDialog v-model="open" persistent max-width="1000">
    <v-card>

      <v-card-title>
        Number Transfer
        <BeehiveIcon :link="articleLinks.transferNumberDialog" />
      </v-card-title>

      <v-form>
        <v-card-text>
          <v-row>

            <v-col cols="12" md="6">
              <v-row>

                <v-col cols="12" md="7">
                  <v-form>

                    <VTextField dense label="Area Code" class="mb-5" @input="$v.areaCode.$touch()" @blur="$v.areaCode.$touch()" :error-messages="areaCodeErrors" outlined :hide-details="areaCodeErrors.length===0" v-model="areaCode" :disabled="isNumberTransferLoading || isEdit || portCompleteDisabled">
                    </VTextField>

                    <VTextField v-if="!numberRangeOpen" dense label="Number" :error-messages="numberErrors" :hide-details="numberErrors.length===0" outlined v-model="number" :disabled="isNumberTransferLoading || isEdit || portCompleteDisabled">
                    </VTextField>

                    <VTextField v-if="numberRangeOpen" class="mb-5" dense label="From" :error-messages="fromNumberErrors" :hide-details="fromNumberErrors.length===0" outlined v-model="fromNumber" :disabled="isNumberTransferLoading || isEdit || portCompleteDisabled">
                    </VTextField>

                    <VTextField v-if="numberRangeOpen" dense :error-messages="toNumberErrors" label="To" :hide-details="toNumberErrors.length===0" outlined v-model="toNumber" :disabled="isNumberTransferLoading || isEdit || portCompleteDisabled">
                    </VTextField>

                  </v-form>
                </v-col>

                <v-col cols="12" md="5">
                  <VSwitch label="Number range" class="mt-0" v-model="numberRangeOpen" :disabled="isNumberTransferLoading || isEdit || portCompleteDisabled"></VSwitch>
                </v-col>

                <v-col cols="12" md="6" class="mt-0">
                  <VSelect :items="currentProviders" label="Current Provider" outlined hide-details v-model="currentProvider" dense :disabled="portCompleteDisabled" @change="mapLosingProvider()" return-object></VSelect>
                </v-col>

                <v-col cols="12" md="6" class="mt-0">
                  <VSelect :items="losingProviders" label="Losing Provider" outlined hide-details v-model="losingProvider" dense :disabled="portCompleteDisabled"></VSelect>
                </v-col>

                <v-col cols="12" md="12" class="mt-0">
                  <VTextField v-model="losing_provider_account_number" label="Losing Provider Account Number" hide-details dense outlined />
                </v-col>

                <v-col cols="12" md="12" class="mt-0">
                  <VSelect :items="lineTypes" :error-messages="lineTypeErrors" label="Line Type" outlined :hide-details="lineTypeErrors.length===0" v-model="lineType" dense :disabled="portCompleteDisabled"></VSelect>
                </v-col>

                <v-col cols="12" md="12" class="mt-0">
                  <VMenu v-model="portingDateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="auto">

                    <template v-slot:activator="{ on, attrs }">
                      <VTextField v-model="portingDate" label="Preferred Porting Date" hide-details readonly v-bind="attrs" v-on="on" dense outlined :disabled="portCompleteDisabled">
                        <v-icon slot="append" color="error" v-if="portingDate!==''&&portingDate!==null&&portingDate!==undefined" @click="portingDate=null;">close</v-icon>
                      </VTextField>
                    </template>

                    <VDatePicker v-model="portingDate" @input="portingDateMenu = false"></VDatePicker>
                    
                  </VMenu>
                </v-col>

                <v-col cols="12" md="12" class="mt-0">
                  <VSelect :items="orderTypes" :error-messages="orderTypeErrors" label="Order Type" outlined :hide-details="orderTypeErrors.length===0" v-model="orderType" dense :disabled="disabledOrderType||!isEdit||isNonGeoNumber"></VSelect>
                </v-col>

                <v-col cols="12" md="12" class="mt-0">
                  <VSelect :items="numberTransferStatuses" :error-messages="numberTransferStatusErrors" label="Number Transfer Status" outlined :hide-details="numberTransferStatusErrors.length===0" v-model="numberTransferStatus" dense :disabled="disabledNumberTransferStatus"></VSelect>
                </v-col>

                <template v-if="showPortingStatus">
                  <v-col cols="12" md="12" class="mt-0">
                    <p class="mb-1 text-caption">Automated Order Status</p>
                    <p><b>{{currentNumberPorting.porting_status}}</b></p>
                  </v-col>
                </template>

                <v-col cols="12">
                  <v-row>

                    <v-col cols="12" md="12">
                      <p class="mb-n3 mt-n3 text-caption">Confirmed Transfer Date</p>
                    </v-col>

                    <v-col cols="12" md="4">
                      <VDialog ref="confirmedTransferDateDateOpen" v-model="confirmedTransferDateDateOpen" :return-value.sync="confirmedTransferDateDate" width="290px">

                        <template v-slot:activator="{ on, attrs }">
                          <VTextField label="Select date" v-model="confirmedTransferDateDate" :allowed-dates="allowedDates" readonly v-bind="attrs" v-on="on" dense hide-details outlined :disabled="disabledNumberTransferStatus"></VTextField>
                        </template>

                        <VDatePicker v-model="confirmedTransferDateDate" :min="todaysDate" scrollable @input="$refs.confirmedTransferDateDateOpen.save(confirmedTransferDateDate);confirmedTransferDateTimeOpen=true;"></VDatePicker>

                      </VDialog>
                    </v-col>

                    <v-col cols="12" md="4">
                      <VDialog ref="confirmedTransferDateTimeOpen" v-model="confirmedTransferDateTimeOpen" :return-value.sync="confirmedTransferDateTime" width="290px">

                        <template v-slot:activator="{ on, attrs }">
                          <VTextField label="Select time" v-model="confirmedTransferDateTime" readonly v-bind="attrs" v-on="on" dense hide-details outlined :disabled="disabledNumberTransferStatus"></VTextField>
                        </template>

                        <VTimePicker v-model="confirmedTransferDateTime" format="24hr" @click:minute="$refs.confirmedTransferDateTimeOpen.save(confirmedTransferDateTime);"></VTimePicker>

                      </VDialog>
                    </v-col>

                    <v-col cols="4" v-if="confirmedTransferDateTime!==''&&confirmedTransferDateDate!==''">
                      <v-icon class="mt-2" @click="resetConfirmedDate">close</v-icon>
                    </v-col>

                  </v-row>
                </v-col>

              </v-row>

              <VRadioGroup v-model="waitingForBroadband" :disabled="isNonGeoNumber">
                <v-row class="mt-n8">

                  <v-col cols="12" md="6">

                    <VRadio label="Wait for broadband" :value="true" />

                    <template v-if="waitingForBroadband">
                      <VTextField v-model="broadbandId" label="Broadband Product ID" class="mt-6" dense outlined :error-messages="broadbandIdErrors" :hide-details="broadbandIdErrors.length===0"></VTextField>
                    </template>

                  </v-col>

                  <v-col cols="12" md="6">
                    <VRadio label="Start immediately" :value="false" />
                  </v-col>

                </v-row>
              </VRadioGroup>

            </v-col>

            <v-col cols="12" md="6">
              <v-row>

                <v-col>
                  <v-btn small color="secondary" :disabled="disableCheckAddress||checkAddressLoading" :loading="checkAddressLoading" @click="checkAddress">CHECK ADDRESS</v-btn>
                </v-col>

                <template v-if="!checkAddressLoading">
                  <v-col class="mt-4 text-right"><p class="text-caption"><AddressCheckStatus :showText="true" :status="checkAddressObj"/></p></v-col>
                </template>

              </v-row>

              <AddressForm @addressSelected="onAddressChanged" :passedAddress="currentNumberPorting.address" :disabled="portCompleteDisabled" :edit="open" />
            </v-col>

          </v-row>
        </v-card-text>
        <v-divider />

        <v-card-actions>

          <template v-if="portCompleteDisabled">
            <v-btn text color="error" x-small>Cannot edit an in progress or completed number transfer</v-btn>
          </template>

          <template v-if="waitingForBroadband===null">
            <v-btn text color="error" x-small>Select either "Waiting for broadband" or "Start immediately"</v-btn>
          </template>

          <v-spacer />

          <v-btn color="primary" small :disabled="isNumberTransferLoading||submitDisabled||portCompleteDisabled" :loading="isNumberTransferLoading" @click.prevent="checkAdditionalNumberCharges();">Save</v-btn>
          <v-btn color="primary" small outlined @click="closeDialog();">CANCEL</v-btn>

        </v-card-actions>
      </v-form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom :timeout="5000">
      {{snackbar_text}}
      <v-btn :color="snackbar_color" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <AdditionalNumberCharges :dialogOpen="addNumberChargesOpen" @close-dialog="addNumberChargesOpen=false;" @confirmed="submit(productId)" />
    
  </VDialog>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";
  
  import { validationMixin } from "vuelidate";
  import { required, numeric, maxLength } from "vuelidate/lib/validators";
  import { formatDateToUTC, createMoment } from '@/helpers';
  import { phoneNumberValidation } from "@/validators";
  import { articleLinks } from '@/helpers/links';

  import moment from "moment";
  import AddressForm from "@/components/Misc/AddressForm";
  import AddressCheckStatus from "@/components/NumberTransfers/AddressCheckStatus";
  import AdditionalNumberCharges from './AdditionalNumberCharges';
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';

  export default {
    components: { AddressForm,AddressCheckStatus,AdditionalNumberCharges, BeehiveIcon },

    mixins: [validationMixin],

    validations() {
      let retObj = {};
      if(this.numberRangeOpen){
        retObj = {
          areaCode: {required,numeric,maxLength:maxLength(5)},
          fromNumber: {required,numeric,phoneNumberValidation},
          toNumber: {required,numeric,phoneNumberValidation},
          lineType: {required},
        }
      } else {
        retObj = {
          areaCode: {required,numeric,maxLength:maxLength(5)},
          number: {required,numeric,phoneNumberValidation},
          lineType: {required},
        }
      }
      if(this.isEdit){
        retObj.orderType = {required};
      }
      retObj.numberTransferStatus = {required};
      if(this.disabledNumberTransferStatus){
        delete retObj.numberTransferStatus;
      }
      if(this.waitingForBroadband){
        retObj.broadbandId = {required};
      }
      return retObj;
    },

    props: {
      productId: { type: Number },
      open: { type: Boolean },
      currentNumberPorting: { type: Object },
    },

    data() {
      return {
        waitingForBroadband: null,
        losing_provider_account_number: '',
        broadbandId: '',
        numberRangeOpen: false,
        currentProvider: "",
        losingProvider: "",
        lineType: "",
        orderType: "",
        numberTransferStatus: "",
        portingDate: "",
        portingDateMenu: false,
        confirmedTransferDateDate: "",
        confirmedTransferDateDateOpen: false,
        confirmedTransferDateTime: "",
        confirmedTransferDateTimeOpen: false,
        todaysDate: this.$options.filters.formatDate(moment(), 'YYYY-MM-DD'),
        number: "",
        snackbar_text: "",
        snackbar_color: "",
        snackbar: false,
        areaCode: "",
        fromNumber: "",
        toNumber: "",
        isEdit: false,
        isNumberTransferLoading: false,
        addNumberChargesOpen: false,

        address: {
          city: "",
          country: "",
          county: "",
          line_one: "",
          line_two: "",
          post_code: "",
        },

        lineTypes:[
          { text: 'Single', value: 'single' },
          { text: 'Multi', value: 'multi' },
        ],

        orderTypes:[
          { text: 'Geographic', value: 'GEOGRAPHIC' },
          { text: 'Manual Geographic', value: 'MANUAL_GEOGRAPHIC' },
          { text: 'IPEX', value: 'IPEX' },
          { text: 'Reseller-to-Reseller', value: 'RESELLER' },
          { text: 'Non-Geographic', value: 'NON_GEOGRAPHIC' },
        ],

        numberTransferStatuses:[
          { text: 'Ready to Port', value: 'READY_TO_PORT'},
          { text: 'Waiting for broadband', value: 'Waiting_for_broadband'},
          { text: 'Porting', value: 'PORTING'},
          { text: 'Ported', value: 'PORTED'},
          { text: 'Cancelled', value: 'CANCELLED'},
        ],

        currentProviders: [
          {text:'1 Com',value:'1 Com',losing:'Gamma'},
          {text:'3CX',value:'3CX',losing:'Magrathea'},
          {text:'4com',value:'4com',losing:'Gamma'},
          {text:'6Degrees',value:'6Degrees',losing:'BT'},
          {text:'AQL Wholesale Ltd',value:'AQL Wholesale Ltd',losing:'Telephony Services (Gradwell)'},
          {text:'bOnline (VoIP)',value:'bOnline (VoIP)',losing:'Gamma'},
          {text:'bOnline (BT)',value:'bOnline (BT)',losing:'BT'},
          {text:'bOnline (TTB)',value:'bOnline (TTB)',losing:'TTB'},
          {text:'Boundless Communications',value:'Boundless Communications',losing:'BT'},
          {text:'Cab Treasure',value:'Cab Treasure',losing:'BT'},
          {text:'Chess ICT',value:'Chess ICT',losing:'BT'},
          {text:'Circle Loop',value:'Circle Loop',losing:'Simwood eSMS Limited'},
          {text:'Circle Loop Mission Labs',value:'Circle Loop Mission Labs',losing:'Simwood eSMS Limited'},
          {text:'Clear Business',value:'Clear Business',losing:'BT'},
          {text:'Connx',value:'Connx',losing:'BT'},
          {text:'Cytel UK',value:'Cytel UK',losing:'BT'},
          {text:'Daisy',value:'Daisy',losing:'BT'},
          {text:'Dial 9 Communications',value:'Dial 9 Communications',losing:'Magrathea'},
          {text:'Direct Save Telecom',value:'Direct Save Telecom',losing:'BT'},
          {text:'E Receptionist',value:'E Receptionist',losing:'Vodafone (Cable & Wireless)'},
          {text:'EE',value:'EE',losing:'BT'},
          {text:'Entropie',value:'Entropie',losing:'BT'},
          {text:'Five Rings Telecoms',value:'Five Rings Telecoms',losing:'Inclarity Communications Ltd (IPEX)'},
          {text:'Focus Group',value:'Focus Group',losing:'BT'},
          {text:'Glamorgan Telecom',value:'Glamorgan Telecom',losing:'Gamma'},
          {text:'Hosted Fudge',value:'Hosted Fudge',losing:'VoiceFlex (IPEX)'},
          {text:'Hyperoptic',value:'Hyperoptic',losing:'Gamma'},
          {text:'IT Logix',value:'IT Logix',losing:'Kalnet4u (IPEX)'},
          {text:'Kinex',value:'Kinex',losing:'BT'},
          {text:'LCC Comms',value:'LCC Comms',losing:'BT'},
          {text:'Moneypenny (Magrathea)',value:'Moneypenny (Magrathea)',losing:'Magrathea'},
          {text:'Moneypenny (Simwood)',value:'Moneypenny (Simwood)',losing:'Simwood eSMS Limited'},
          {text:'Number People',value:'Number People',losing:'IP Voice Networks Ltd (IPEX)'},
          {text:'Onebill Telecom',value:'Onebill Telecom',losing:'TTB'},
          {text:'Sipcentric',value:'Sipcentric',losing:'Telephony Services (Gradwell)'},
          {text:'Sipgate',value:'Sipgate',losing:'Magrathea'},
          {text:'Skype',value:'Skype',losing:'Vodafone (Cable & Wireless)'},
          {text:'Skype (IPEX)',value:'Skype (IPEX)',losing:'Wavecrest (IPEX)'},
          {text:'Smart Numbers',value:'Smart Numbers',losing:'Vodafone (Cable & Wireless)'},
          {text:'Soho66',value:'Soho66',losing:'Telephony Services (Gradwell)'},
          {text:'Switchboard Free',value:'Switchboard Free',losing:'Liquid 11 (IPEX)'},
          {text:'Plan.com',value:'Plan.com',losing:'Magrathea'},
          {text:'Plusnet (BT)',value:'Plusnet (BT)',losing:'BT'},
          {text:'Plusnet (TTB)',value:'Plusnet (TTB)',losing:'TTB'},
          {text:'Port5060',value:'Port5060',losing:'KCOM (BT)'},
          {text:'Priemier Choice Group',value:'Priemier Choice Group',losing:'BT'},
          {text:'Ring Central',value:'Ring Central',losing:'BT'},
          {text:'Sipcentric',value:'Sipcentric',losing:'Telephony Services (Gradwell)'},
          {text:'Sipgate',value:'Sipgate',losing:'Magrathea'},
          {text:'Skype (Non-Geo)',value:'Skype (Non-Geo)',losing:'New Call Telecom'},
          {text:'Skype (Vodafone)',value:'Skype (Vodafone)',losing:'Vodafone (Cable & Wireless)'},
          {text:'Skype (Wavecrest)',value:'Skype (Wavecrest)',losing:'Wavecrest'},
          {text:'Smart Numbers',value:'Smart Numbers',losing:'Vodafone (Cable & Wireless)'},
          {text:'Soho66',value:'Soho66',losing:'Telephony Services (Gradwell)'},
          {text:'Switchboard Free',value:'Switchboard Free',losing:'Liquid 11'},
          {text:'Tamar Telecom',value:'Tamar Telecom',losing:'Kalnet4u'},
          {text:'Telesis',value:'Telesis',losing:'BT'},
          {text:'The VoIP Shop',value:'The VoIP Shop',losing:'BT'},
          {text:'Timico (KCOM)',value:'Timico (KCOM)',losing:'KCOM (Affiniti)'},
          {text:'Timico (Magrathea)',value:'Timico (Magrathea)',losing:'Magrathea'},
          {text:'Timico',value:'Timico',losing:'KCOM (Affiniti)'},
          {text:'TML',value:'TML',losing:'TTB'},
          {text:'Two Circles',value:'Two Circles',losing:'AQL Wholesale Ltd'},
          {text:'Unicom (BT)',value:'Unicom (BT)',losing:'BT'},
          {text:'Unicom (TTB)',value:'Unicom (TTB)',losing:'TTB'},
          {text:'Utility Warehouse',value:'Utility Warehouse',losing:'BT'},
          {text:'Virtual Landline (Buzz Networks)',value:'Virtual Landline (Buzz Networks)',losing:'Buzz Networks'},
          {text:'Virtual Landline (Magrathea)',value:'Virtual Landline (Magrathea)',losing:'Magrathea'},
          {text:'Voipfone',value:'Voipfone',losing:'Net Telecoms (IPEX)'},
          {text:'Vonage',value:'Vonage',losing:'Gamma'},
          {text:'Woav',value:'Woav',losing:'TTB'},
          {text:'Yay.com',value:'Yay.com',losing:'Simwood eSMS Limited'},
          {text:'XLN (BT)',value:'XLN (BT)',losing:'XLN (BT)'},
          {text:'XLN (Talk Talk)',value:'XLN (Talk Talk)',losing:'XLN (Talk Talk)'},
          {text:'Yestech',value:'Yestech',losing:'Magrathea'},
          {text:'Zen Telecoms',value:'Zen Telecoms',losing:'BT'},
        ],

        losingProviders: [
          {text:'AQL Wholesale Ltd',value:'AQL Wholesale Ltd'},
          {text:'BT',value:'BT'},
          {text:'BT Openreach',value:'BT Openreach'},
          {text:'Buzz Networks',value:'Buzz Networks'},
          {text:'TTB',value:'TTB'},
          {text:'Vodafone',value:'Vodafone'},
          {text:'Virgin Media',value:'Virgin Media'},
          {text:'Barritel Limited',value:'Barritel Limited'},
          {text:'BSKYB LLU Assets Limited',value:'BSKYB LLU Assets Limited'},
          {text:'Colt',value:'Colt'},
          {text:'Invoco Ltd',value:'Invoco Ltd'},
          {text:'KCOM (Affiniti)',value:'KCOM (Affiniti)'},
          {text:'KCOM (BT)',value:'KCOM (BT)'},
          {text:'Magrathea',value:'Magrathea'},
          {text:'Mintaka Limited',value:'Mintaka Limited'},
          {text:'New Call Telecom',value:'New Call Telecom'},
          {text:'Opal Telecom (Talk Talk)',value:'Opal Telecom (Talk Talk)'},
          {text:'Orange Business',value:'Orange Business'},
          {text:'Resilient PLC',value:'Resilient PLC'},
          {text:'Simwood eSMS Limited',value:'Simwood eSMS Limited'},
          {text:'Spitfire',value:'Spitfire'},
          {text:'Storacall (X-ON)',value:'Storacall (X-ON)'},
          {text:'Telephony Services (Gradwell)',value:'Telephony Services (Gradwell)'},
          {text:'Verizon',value:'Verizon'},
          {text:'Viatel (UK) Ltd (VTL)',value:'Viatel (UK) Ltd (VTL)'},
          {text:'Virgin Media (Eurobell)',value:'Virgin Media (Eurobell)'},
          {text:'Virgin Media (NTL)',value:'Virgin Media (NTL)'},
          {text:'Virgin Media (Telewest)',value:'Virgin Media (Telewest)'},
          {text:'Vodafone (Cable & Wireless)',value:'Vodafone (Cable & Wireless)'},
          {text:'Vodafone (Energis)',value:'Vodafone (Energis)'},
          {text:'Vodafone (Thus)',value:'Vodafone (Thus)'},
          {text:'Vodafone (Your Comms)',value:'Vodafone (Your Comms)'},
          {text:'VoIP-UN Limited',value:'VoIP-UN Limited'},
          {text:'Voxbone SA',value:'Voxbone SA'},
          {text:'Opal Telecom (Talk Talk)',value:'Opal Telecom (Talk Talk)'},
          {text:'XLN (BT)',value:'XLN (BT)'},
          {text:'XLN (Talk Talk)',value:'XLN (Talk Talk)'},
          {text:'Gamma',value:'Gamma'},
          {text:'Inclarity Communications Ltd (IPEX)',value:'Inclarity Communications Ltd (IPEX)'},
          {text:'IP Voice Networks Ltd (IPEX)',value:'IP Voice Networks Ltd (IPEX)'},
          {text:'Kalnet4u',value:'Kalnet4u'},
          {text:'Kalnet4u (IPEX)',value:'Kalnet4u (IPEX)'},
          {text:'Liquid 11',value:'Liquid 11'},
          {text:'Liquid 11 (IPEX)',value:'Liquid 11 (IPEX)'},
          {text:'Net Telecoms (IPEX)',value:'Net Telecoms (IPEX)'},
          {text:'VoiceFlex (IPEX)',value:'VoiceFlex (IPEX)'},
          {text:'Wavecrest',value:'Wavecrest'},
          {text:'Wavecrest (IPEX)',value:'Wavecrest (IPEX)'},
        ],

        articleLinks,

        isNonGeoNumber: false
      };
    },

    computed: {

      ...mapState('products',['productNumbers']),
      ...mapState('numbers',['checkAddressObj','checkAddressLoading']),
      ...mapGetters("globals", ['hasUserGotRole']),

      showPortingStatus(){
        let status = this.currentNumberPorting.porting_status;
        return status!==null&&status!==undefined;
      },

      submitDisabled(){
        if(this.address===undefined||this.address===null){ return true; }
        return (
          this.areaCode==='' ||
          this.number==='' ||
          this.losingProvider==='' ||
          this.address.city==='' ||
          this.address.country==='' ||
          this.address.county==='' ||
          this.address.line_one==='' ||
          this.address.post_code==='' ||
          this.waitingForBroadband===null ||
          this.currentProvider==='' ||
          this.losingProvider===''
        );
      },

      broadbandIdErrors() {
        const errors = [];
        if (!this.$v.broadbandId.$dirty) return errors;
        !this.$v.broadbandId.required && errors.push("This is a required field");
        return errors;
      },

      lineTypeErrors() {
        const errors = [];
        if (!this.$v.lineType.$dirty) return errors;
        !this.$v.lineType.required && errors.push("This is a required field");
        return errors;
      },

      orderTypeErrors() {
        const errors = [];
        if(this.isEdit){
          if (!this.$v.orderType.$dirty) return errors;
          !this.$v.orderType.required && errors.push("This is a required field");
        }
        return errors;
      },

      numberTransferStatusErrors() {
        const errors = [];
        if(!this.disabledNumberTransferStatus){
          if (!this.$v.numberTransferStatus.$dirty) return errors;
          !this.$v.numberTransferStatus.required && errors.push("This is a required field");
        }
        return errors;
      },

      areaCodeErrors() {
        const errors = [];
        if (!this.$v.areaCode.$dirty) return errors;
        !this.$v.areaCode.required && errors.push("This is a required field");
        !this.$v.areaCode.numeric &&
          errors.push("This field can only contains digits.");
        !this.$v.areaCode.maxLength &&
          errors.push("This field must be a 5-digit number.");
        return errors;
      },

      numberErrors() {
        const errors = [];
        if(!this.numberRangeOpen){
          if (!this.$v.number.$dirty) return errors;
          !this.$v.number.required && errors.push("This is a required field");
          !this.$v.number.numeric &&
            errors.push("This field can only contains digits.");
          !this.$v.number.phoneNumberValidation &&
            errors.push("Please input a valid UK phone number.");
        }
        return errors;
      },

      fromNumberErrors() {
        const errors = [];
        if(this.numberRangeOpen){
          if (!this.$v.fromNumber.$dirty) return errors;
          !this.$v.fromNumber.required && errors.push("This is a required field");
          !this.$v.fromNumber.numeric &&
            errors.push("This field can only contains digits.");
          !this.$v.fromNumber.phoneNumberValidation &&
            errors.push("Please input a valid UK phone number.");
        }
        return errors;
      },

      toNumberErrors() {
        const errors = [];
        if(this.numberRangeOpen){
          if (!this.$v.toNumber.$dirty) return errors;
          !this.$v.toNumber.required && errors.push("This is a required field");
          !this.$v.toNumber.numeric &&
            errors.push("This field can only contains digits.");
          !this.$v.toNumber.phoneNumberValidation &&
            errors.push("Please input a valid UK phone number.");
        }
        return errors;
      },

      portCompleteDisabled(){
        let cnp = this.currentNumberPorting;
        if(cnp.status!==undefined){
          if(cnp.status==='Porting'&&['COMMITTED','COMPLETED'].indexOf(cnp.porting_status)!==-1){
            return true;
          }
        }
        return false;
      },

      disabledConfirmedTransferDate(){
          return this.orderType !== 'MANUAL_GEOGRAPHIC';
      },

      disabledOrderType(){
        let cnp = this.currentNumberPorting;
        if(cnp.status!==undefined){
          if(cnp.status==='Porting'&&['PENDING','COMMITTED','COMPLETED'].indexOf(cnp.porting_status)!==-1){
            return true;
          }
        }
        return false;
      },

      disabledNumberTransferStatus(){
        if(['MANUAL_GEOGRAPHIC','IPEX','RESELLER', 'NON_GEOGRAPHIC'].indexOf(this.orderType)!==-1){
          if(this.hasUserGotRole('number-transfer-manager')){
            if(this.isEdit){
              if(this.currentNumberPorting.status==='WAITING_FOR_BROADBAND'){
                return true;
              }else if(this.currentNumberPorting.status==='READY_TO_PORT'){
                this.numberTransferStatuses = [{ text: 'Porting', value: 'PORTING'},{ text: 'Cancelled', value: 'CANCELLED'}];
              }else if(this.currentNumberPorting.status==='PORTING'){
                this.numberTransferStatuses = [{ text: 'Ported', value: 'PORTED'},{ text: 'Cancelled', value: 'CANCELLED'}];
              }
              return false;
            }
          }
        }
        return true;
      },

      disableCheckAddress(){
        if(this.number===''||this.number===undefined||this.address===undefined||this.address===null){ return true; }
        return false;
      },

    },

    watch: {

      currentNumberPorting (newValue) {
        this.isEdit = newValue && newValue.id ? true: false;
        this.waitingForBroadband = null;
        if(newValue.broadband_product_id!==null&&newValue.broadband_product_id!==undefined){this.waitingForBroadband = (newValue.broadband_product_id!==null);}
        if(this.waitingForBroadband){ this.broadbandId = newValue.broadband_product_id; }
        if(this.isEdit){ this.waitingForBroadband = (newValue.broadband_product_id!==null); }
        this.areaCode = newValue.area_code;
        this.lineType = newValue.pstn_line_type;
        this.orderType = newValue.port_kind;
        this.numberTransferStatus = newValue.status;
        if(this.isEdit){
          this.numberRangeOpen = (newValue.numbers && newValue.numbers.length > 1);
          this.fromNumber = newValue.porting_range_start;
          this.toNumber = Number(newValue.porting_range_start) + (newValue.numbers.length - 1);
          this.toNumber = ('00000000000'+this.toNumber).slice(-11);
        }else{
          this.numberRangeOpen = false;
        }
        this.number = newValue.porting_range_start;
        this.currentProvider = newValue.current_provider;
        this.losingProvider = newValue.losing_provider;
        this.address = newValue.address;
        this.portingDate = newValue.preferred_porting_date;
        let confirmedTransferDate = createMoment(newValue.confirmed_transfer_date);
        if(newValue.confirmed_transfer_date === null||newValue.confirmed_transfer_date === undefined){
          this.confirmedTransferDateDate = '';
          this.confirmedTransferDateTime = '';
        }else{
          this.confirmedTransferDateDate = confirmedTransferDate.format('YYYY-MM-DD');
          this.confirmedTransferDateTime = confirmedTransferDate.format('HH:mm');
        }
      },

      number(number){
        const isNonGeo = /^033/g.test(number);

        if(isNonGeo){
          this.orderType = 'NON_GEOGRAPHIC';
          this.isNonGeoNumber = true;
          this.waitingForBroadband = false;
        }else{
          this.orderType = this.currentNumberPorting.port_kind;
          this.isNonGeoNumber = false;

          if (this.isEdit) {
            this.waitingForBroadband = this.currentNumberPorting.broadband_product_id !== null && this.currentNumberPorting.broadband_product_id !== undefined;
          }
        }
      },

    },

    mounted() {
      if(this.currentNumberPorting) {
        this.waitingForBroadband = null;
        if(this.currentNumberPorting.broadband_product_id!==null&&this.currentNumberPorting.broadband_product_id!==undefined){ this.waitingForBroadband = this.currentNumberPorting.broadband_product_id!==null; }
        if(this.waitingForBroadband){ this.broadbandId = this.currentNumberPorting.broadband_product_id; }
        this.areaCode = this.currentNumberPorting.area_code;
        this.lineType = (this.currentNumberPorting.pstn_line_type!==undefined)?this.currentNumberPorting.pstn_line_type:'single';
        this.orderType = this.currentNumberPorting.port_kind;
        this.losing_provider_account_number = this.currentNumberPorting.losing_provider_account_number;
        this.numberTransferStatus = this.currentNumberPorting.status;
        this.numberRangeOpen = false;
        this.number = this.currentNumberPorting.porting_range_start;
        this.isEdit = this.currentNumberPorting && this.currentNumberPorting.id ? true: false;
        this.currentProvider = this.currentNumberPorting.current_provider;
        this.losingProvider = this.currentNumberPorting.losing_provider;
        this.portingDate = this.currentNumberPorting.preferred_porting_date;
       
        if(this.currentNumberPorting.address!== undefined){
          this.address = this.currentNumberPorting.address;
        }
      }
      let compare = (a,b)=>{
        const itemA = a.text.toUpperCase();
        const itemB = b.text.toUpperCase();
        let comparison = 0;
        if(itemA>itemB){comparison=1;}else if(itemA<itemB){comparison=-1;}
        return comparison;
      }
      this.currentProviders.sort(compare);
      this.losingProviders.sort(compare);
    },

    methods: {
      ...mapActions('numbers',['checkAddressAPI','transferNumber', 'updateNumberPorting', 'resetState']),
      ...mapActions('upfrontcosts',['fetchUpfrontCostsById']),
      ...mapActions("globals", ['setSelectedAddress']),

      resetConfirmedDate(){
        this.confirmedTransferDateDate = '';
        this.confirmedTransferDateTime = '';
      },

      async checkAddress(){
        let data = {
          number: this.number,
          post_code: this.address.post_code.replace(' ',''),
        };
        await this.checkAddressAPI(data);
      },

      allowedDates: val => moment(val) >= this.todaysDate,

      closeDialog(){
        this.$emit('closeDialog');
        this.reset();
      },

      mapLosingProvider(){
        this.losingProvider = this.currentProvider.losing;
      },

      reset(){
        this.waitingForBroadband=null;
        this.broadbandId = '';
        this.losing_provider_account_number='';
        this.numberRangeOpen=false;
        this.currentProvider="";
        this.losingProvider="";
        this.number="";
        this.orderType="";
        this.numberTransferStatus="";
        this.lineType="";
        this.snackbar_text="";
        this.snackbar_color="";
        this.snackbar=false;
        this.areaCode="";
        this.fromNumber="";
        this.toNumber="";
        this.isEdit=false;
        this.isNumberTransferLoading=false;
        this.setSelectedAddress({city:'',country:'',county:'',line_one:'',line_two:'',post_code:''});
        this.address={};
        this.resetState();
        this.$v.$reset();
      },

      onAddressChanged(address) {
        this.address = address;
      },

      checkAdditionalNumberCharges(){
        if(this.productNumbers.length>0){
          this.addNumberChargesOpen = true;
        }else{
          this.submit(this.productId);
        }
      },

      async submit(productId) {

        this.$v.$touch();

        if (!this.$v.$invalid) {
          let data = {
            status: '',
            non_geographic: false,
            area_code: this.areaCode,
            porting_range_start: this.numberRangeOpen ? this.fromNumber : this.number,
            porting_range_length: (!this.numberRangeOpen) ? 1 : (this.toNumber - this.fromNumber + 1),
            pstn_line_type: (this.lineType==='single') ? "SINGLE" : "MULTI",
            preferred_porting_date: this.portingDate,
            current_provider: this.currentProvider ? this.currentProvider.value : null,
            losing_provider: this.losingProvider,
            address: this.address,
            no_broadband_on_line: false,
            port_kind: this.orderType,
            wait_for_broadband: this.waitingForBroadband,
            losing_provider_account_number: this.losing_provider_account_number,
            broadband_product_id: (this.broadbandId!==''&&this.waitingForBroadband)?this.broadbandId:null,
          }

          if(this.isEdit){
            if(this.waitingForBroadband){
              data.status = 'WAITING_FOR_BROADBAND';
            }else{
              if(!this.disabledNumberTransferStatus){
                data.status = this.numberTransferStatus;
              }else{
                data.status = 'READY_TO_PORT';
              }
            }
          }else{
            data.status = 'PORTING';
          }

          if (!this.disabledNumberTransferStatus && this.confirmedTransferDateDate) {
            data.confirmed_transfer_date = formatDateToUTC(
              this.confirmedTransferDateDate +
              (this.confirmedTransferDateTime ? ' ' + this.confirmedTransferDateTime : '')
            );
          }else{
            data.confirmed_transfer_date = null;
          }
          if(data.confirmed_transfer_date===' '){ data.confirmed_transfer_date = null; }
          this.isNumberTransferLoading = true;
          if(this.currentNumberPorting.id){
            const numberRangeId = this.currentNumberPorting.id
            let success = await this.updateNumberPorting({ numberRangeId, data });
            this.isNumberTransferLoading = false;
            if(success){
              this.closeDialog();
              this.$emit('refresh-numbers');
            }
          }else{
            let success = await this.transferNumber({ productId, data });
            this.isNumberTransferLoading = false;
            if(success){
              this.fetchUpfrontCostsById(this.productId);
              this.closeDialog();
              this.$emit('refresh-numbers');
            }
          }
          
        }
      },

    },
  };
</script>

<style></style>
